enum DateType {
  ALL_TIME = 'all-time',
  CALENDAR_YTD = 'calendar-ytd',
  CUSTOM_DATES = 'custom-dates',
  FISCAL_YTD = 'fiscal-ytd',
  LAST_MONTH = 'last-month',
  LAST_30_DAYS = 'last-30-days',
  LAST_6_MONTHS = 'last-6-months',
  LAST_12_MONTHS = 'last-12-months',
}

export default DateType;
